import { Grid } from '@material-ui/core';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import { IconComment } from 'icons';
import { useEffect, useState } from 'react';
import { NotesStyle } from './style';

const NoteView = ({ note }) => {
    const classes = NotesStyle();

    const [html, setHTML] = useState({ __html: "" });

    useEffect(() => {
        setHTML({ __html: note.content })
    }, [note]);

    return (
        <Grid container alignItems='center'>
            <Grid className={classes.noteIconWrapper}>
                {note.isHotNote ? <WhatshotIcon fontSize='small' className={classes.hotNoteIcon} /> : <IconComment width='13' height='13'/>}
            </Grid> <Grid><div dangerouslySetInnerHTML={html} /></Grid>
        </Grid>
    );
}
export default NoteView;